// extracted by mini-css-extract-plugin
export default {"root":"Unsubscribe_root__LkCnS"};